import { StatusType } from '@oy/types';

export const ACCOUNT_STATEMENT_STATUSES: StatusType[] = [
  'FAILED',
  'FAILED_FORCE_CREDIT',
  'PENDING',
  'PENDING_FORCE_CREDIT',
  'SUCCESS',
  'CANCELED',
];

export const SETTLEMENT_REPORT_STATUSES: StatusType[] = [
  'IN_PROGRESS',
  'SUCCESS',
  'WAITING',
  'VOID',
];

export const DISBURSEMENT_STATUSES: StatusType[] = [
  'CANCEL',
  'FINISH',
  'INCOMPLETE',
  'PENDING_APPROVAL',
  'RUNNING',
  'SCHEDULED',
  'WAITING_PAYMENT',
];

export const PRODUCT_STATUSES: StatusType[] = [
  'APPROVED',
  'BLOCKED',
  'NEED_REVISION',
  'NOT_SUBMITTED',
  'REJECTED',
  'RESUBMITTED',
  'SUBMITTED',
];
